export enum DeliveryTaskState {
    WaitingForAccept = 1,
    NotAccepted = 2,
    ToDo = 3,
    InProgress = 4,
    Done = 5,
    Failed = 6,
    Canceled = 7,
}
